package api.data

import dev.gitlive.firebase.firestore.DocumentSnapshot
import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class DataVisitSchedule(
    @SerialName("id")
    var id: String? = null,

    @SerialName("name")
    var name: String? = null,

    @SerialName("email")
    var email: String? = null,

    @SerialName("phone")
    var phone: String? = null,

    @SerialName("date")
    var date: String? = null,

    @SerialName("propertyId")
    var propertyId: String? = null,

    @SerialName("propertyName")
    var propertyName: String? = null,

    @SerialName("propertyLocation")
    var propertyLocation: String? = null,

    @SerialName("propertyType")
    var propertyType: String? = null,

    @SerialName("approveBy")
    var approvedBy: String? = null,

    @SerialName("approvedOn")
    var approvedOn: Timestamp? = null,

    @SerialName("timestamp")
    var timestamp: Timestamp? = null,

    @SerialName("visitStatus")
    var visitStatus: String? = null,

    @SerialName("visitedOn")
    var visitedOn: String? = null,

    @SerialName("visitOn")
    var visitOn: String? = null,
)


fun DocumentSnapshot.toDataVisitSchedule(): DataVisitSchedule{
    return DataVisitSchedule(
        id = get("id"),
        name = get("name"),
        email = get("email"),
        phone = get("phone"),
        date = get("date"),
        propertyId = get("propertyId"),
        propertyName = get("propertyName"),
        propertyLocation = get("propertyLocation"),
        propertyType = get("propertyType"),
        approvedBy = get("approvedBy"),
        approvedOn = get("approvedOn"),
        timestamp = get("timestamp"),
        visitStatus = get("visitStatus"),
        visitedOn = get("visitedOn"),
        visitOn = get("visitOn")
    )
}